<template>
    <svg
        :width="size"
        :height="size"
        viewBox="0 0 24 24"
        :fill="color"
        xmlns="http://www.w3.org/2000/svg"
        :style="{ color }"
    >
        <path
            d="M18.8571 24V22.2857H18.1607C17.1607 22.2857 16.2946 22.1875 15.5625 21.9911C14.8304 21.7946 14.3036 21.5804 13.9821 21.3482C13.6607 21.1161 13.4018 20.8571 13.2054 20.5714C13.0089 20.2857 12.9018 20.0804 12.8839 19.9554C12.8661 19.8304 12.8571 19.7321 12.8571 19.6607V17.8929C13.6786 17.6429 14.5 17.0893 15.3214 16.2321C16.8214 15.875 18.1964 15.25 19.4464 14.3571C20.9107 13.2857 22.0357 11.9464 22.8214 10.3393C23.6071 8.73214 24 6.55357 24 3.80357V3.42857H19.6607C19.7321 2.17857 19.7321 1.03571 19.6607 0H4.28571V3.42857H0V5.14286C0.0714286 7.10714 0.464286 8.83929 1.17857 10.3393C1.96429 11.9464 3.08929 13.2857 4.55357 14.3571C5.73214 15.2143 7.10714 15.8393 8.67857 16.2321C9.5 17.0893 10.3214 17.6429 11.1429 17.8929V19.8214C10.8571 21.4643 9.08929 22.2857 5.83929 22.2857H5.14286V24H18.8571ZM6.85714 13.7679C5.03571 12.875 3.66071 11.4821 2.73214 9.58929C2.125 8.30357 1.78571 6.82143 1.71429 5.14286H4.44643C4.51786 5.78571 4.57143 6.25 4.60714 6.53571C5.14286 9.60714 5.89286 12.0179 6.85714 13.7679ZM17.0893 13.7679C18.0536 12.0179 18.8036 9.60714 19.3393 6.53571C19.3393 6.39286 19.3661 6.16964 19.4196 5.86607C19.4732 5.5625 19.5179 5.32143 19.5536 5.14286H22.2857C22.2143 6.82143 21.875 8.30357 21.2679 9.58929C20.375 11.4464 18.9821 12.8393 17.0893 13.7679V13.7679ZM12 3C14.7614 3 17 5.23858 17 8C17 10.7614 14.7614 13 12 13C9.23858 13 7 10.7614 7 8C7 5.23858 9.23858 3 12 3ZM12 5C11.7239 5 11.5 5.22386 11.5 5.5V8.5C11.5 8.77614 11.7239 9 12 9C12.0086 9 12.0171 8.99978 12.0256 8.99936L14.5 8.99798C14.7761 8.99798 15 8.77412 15 8.49798C15 8.22184 14.7761 7.99798 14.5 7.99798L12.4996 7.9976L12.5 5.5C12.5 5.22386 12.2761 5 12 5V5Z"
        />
    </svg>
</template>

<script>
import VueTypes from 'vue-types';

export default {
    name: 'OtcSVG',
    props: {
        size: VueTypes.number.isRequired,
        color: VueTypes.string.isRequired,
    },
};
</script>

<style></style>
